// pipe: 4B.9 (Task 5) — Customers sidebar entry (links to the staff Customers management screen).
// Cloned from ops-button.tsx (verbatim shape) — only the route, the active-path prefix, the icon,
// the label key, and the testid differ.
import { useI18n } from '@affine/i18n';
import { MemberIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const CustomersButton = () => {
  const t = useI18n();
  const { workbenchService } = useServices({ WorkbenchService });
  const workbench = workbenchService.workbench;
  // REACTIVE active state: any `/customers` route keeps the entry lit.
  const active = useNavPrefixActive(workbench, '/customers');

  return (
    <MenuLinkItem icon={<MemberIcon />} active={active} to={'/customers'}>
      <span data-testid="pipe-customers-nav">
        {t['com.affine.pipe.customers.nav']()}
      </span>
    </MenuLinkItem>
  );
};
